import React from "react";
import PokeNav from './PokeNav'

const Header = () => {
  return <header>
    <PokeNav />
  </header>
};

export default Header;